import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksTemplateCreateRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-template-create',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/template/:templateId',
	exact: true,
};
